import { createContext, useContext } from 'react';

/** The order the Updates tab is showing, for row-level analytics without prop drilling. */
export const UpdatesOrderContext = createContext('');
export const useUpdatesOrderUid = () => useContext(UpdatesOrderContext);
